export enum PartTypeKind {
  'single' = 'single',
  'composite' = 'composite',
}
export interface IPartType {
  _id: string;
  key: string;
  name: string;
  description?: string;
  imageUrl?: string;
  subcategories?: IPartType[];
}

export interface IPart {
  _id: string;
  name: string;
  description: string;
  imageUrl: string;
  brandId: string;
  partTypeId: string[];
  officialUrl: string;
  expired: boolean;
  compositeParts?: IPart[];
}

export interface ISimpleResponce<T> {
  status: number;
  message?: string;
  errors?: string[];
  data: T;
}
